import { Stack } from '@mui/material';
import { RequestType } from '@silbo/core';
import { colors, EmergencyIcon, EntryDashedIcon, UnitIcon } from '@silbo/ui';
import { ReactNode } from 'react';

type ExtendedRequestType = Extract<RequestType, 'INTERNAL_MUTATION' | 'DIRECT_ADMISSION'> | 'EMERGENCY';

type RequestTypeIconProps = {
  type: ExtendedRequestType;
};

const RequestTypeIcon = ({ type }: RequestTypeIconProps) => {
  return (
    <Stack
      borderRadius={1}
      width={40}
      height={40}
      justifyContent="center"
      alignItems="center"
      bgcolor={colorByType[type]}
      color="white"
    >
      {iconByType[type]}
    </Stack>
  );
};

const colorByType: Record<ExtendedRequestType, string> = {
  INTERNAL_MUTATION: colors.blue[30],
  DIRECT_ADMISSION: colors.purple[50],
  EMERGENCY: colors.orange[50],
};

const iconByType: Record<ExtendedRequestType, ReactNode> = {
  INTERNAL_MUTATION: <UnitIcon sx={{ fontSize: 20 }} />,
  DIRECT_ADMISSION: <EntryDashedIcon sx={{ fontSize: 20 }} />,
  EMERGENCY: <EmergencyIcon sx={{ fontSize: 20 }} />,
};

export default RequestTypeIcon;
